import React from 'react';
import {
    withStyles,
    IconButton,
    ListItem,
    Grid,
    Typography,
    List,
    Avatar,
} from '@material-ui/core';


import {
    withRouter,
} from "react-router-dom"

import AppData from '../../model/AppData';
import MBack from '../view/MBack';
import AppUtils from '../../control/apputlis';
import ChatItem from './ChatItem';
import Apis from '../../network/Apis';
import FIMUtils from '../../im/FIMUtils';
import IMEventEmitter, { IMEvent } from '../../net/IMEventEmitter'
import IMApp from '../../net/IMApp';



const ICON_ADD_FRIEND = require('../../images/icons/icon_add_friend.png');

class ChatPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            avatar: AppData.me.Pic,
            friendList: [],
            is_group: false,
            newMessage: [],
            applyPoint: false,
        }
        document.body.style.overflow = 'scroll';

    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'ChatPage');
        IMEventEmitter.on(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
        IMEventEmitter.on(IMEvent.EVENT_FRIEND_LIST, this.onFriendList, this);
        IMEventEmitter.on(IMEvent.S2C_MSG_RED_NTY_APPLY_NUM, this.onShowPointEvent, this);
        this.checkGroupRule();
        this.getFrendsList();
        this.getApplyFriendList()
    }

    componentWillUnmount() {
        this.setState = () => false;
        IMEventEmitter.off(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
        IMEventEmitter.off(IMEvent.EVENT_FRIEND_LIST, this.onFriendList, this);
        IMEventEmitter.off(IMEvent.S2C_MSG_RED_NTY_APPLY_NUM, this.onShowPointEvent, this);
    }

    getApplyFriendList = async () => {
        //检查是否有好友申请
        let list = await IMApp.getApplyFriendList();
        // console.log(list);
        this.state.newFriend = list
        // if (list.length > 0) {
        //     this.setState({ applyPoint: true, showPoint: true });
        // }
    }

    onShowPointEvent = async () => {
        //检查是否有新的好友申请

        let list = IMApp.applylist

        let oldData = IMApp.getFriendList();


        let data = [];
        for (let i = 0; i < list.length; i++) {
            let exist = false;

            for (let j = 0; j < oldData.length; j++) {
                if (list[i].uid == oldData[j].uid) {
                    exist = true;
                }
            }

            if (!exist) {
                data.push(list[i]);
            }
        }
        //新的好友请求

        if (data.length === 0) {
            return
        }
        this.setState({ applyPoint: true, showPoint: true });
    }

    onMessageReceived = (event) => {
        console.log('onMessageReceived===>', event);
        if (event && event.length > 0) {
            this.setState({ showPoint: true, newMessage: event });
        }
    }

    onFriendList = () => {
        this.getFrendsList();
    }

    checkGroupRule = async () => {
        let isLogin = AppData.me.isLogin();
        let result = await Apis.checkGroupRule(isLogin ? 1 : 2, AppData.me.getUid());
        console.log('checkGroupRule', result);
        if (result.code == 200 && result.data) {
            this.setState({ is_group: result.data.is_group })
        }
    }

    getFrendsList = () => {
        let data = FIMUtils.getFriendList();
        let list = [];
        for (let i = 0; i < data.length; i++) {
            if (!list[data[i].firstLetter]) {
                list[data[i].firstLetter] = []
            }
            list[data[i].firstLetter].push(data[i]);
        }
        let temp = [];
        for (let k in list) {
            temp.push({ sort: k, list: list[k] })
        }

        temp = temp.sort((a, b) => {
            if (a.sort == "#") {
                return 1
            }
            if (b.sort == "#") {
                return -1
            }
            return a.sort.charCodeAt(0) - b.sort.charCodeAt(0);
        });

        console.log(temp)

        this.setState({ friendList: temp });

    }

    //查找元素的下标
    seachIndex = (str, array) => {
        let index = 0;
        for (let i = 0; i < array.length; i++) {
            const element = array[i];
            if (str == array.sort) {
                index = i;
                continue;
            }

        }
        return index
    }

    _onListItemClick = (data) => {
        console.log('_onListItemClick====>', data);
        let nick = data.nickname;
        let userId = FIMUtils.createChatKey(data.uid);//data.uid; 
        this.props.history.push({ pathname: '/privateletter/' + userId + '/userProfile', data: nick });
    }

    _onClickSysMsg = () => {
        console.log('_onClickSysMsg');
        const { sysmsg } = this.state;
        this.props.history.push({ pathname: '/sysmessage/', data: sysmsg });
    }

    _onSearchFriend = () => {
        const { sysmsg } = this.state;
        this.props.history.push({ pathname: '/chatsearchfriend/', data: sysmsg });
    }

    onQunliao = () => {
        this.props.history.push({ pathname: '/chatgroup/' });
    }

    onAddNewFriend = () => {
        this.setState({ applyPoint: false, showPoint: false });
        this.props.history.push({ pathname: '/chataddfriend/' });
    }

    getShowPoint = (chatkey) => {
        const { newMessage } = this.state;
        if (newMessage.length == 0) {
            return false;
        }
        for (let i = 0; i < newMessage.length; i++) {
            if (newMessage[i].chatkey == chatkey) {
                return true;
            }
        }
        return false;
    }

    renderItem = (data, n, isDiv) => {
        const { classes } = this.props;
        let showPoint = this.getShowPoint(data.chatkey);

        let avatar = data.headurl;
        let nick = data.nickname;
        let userId = data.fid;


        return (
            <ListItem key={n} disableRipple button onClick={() => this._onListItemClick(data)} style={{ paddingLeft: 8, paddingRight: 8, margin: 0, paddingTop: 0 }}>
                <Grid container direction='column'>
                    <Grid justifycontent='space-between'>
                        <Grid container direction='row' alignItems="center"
                        //  style={{ flex: 1, borderBottom: 1, borderBottomColor: '#F2F2F2' }}
                        >
                            <Grid container direction='row' style={{ alignItems: 'flex-start', width: 40, height: 40 }}>
                                <Avatar src={avatar} className={classes.menuIcon} />
                                {
                                    showPoint && <Grid style={{ backgroundColor: '#FC3035', marginLeft: 0, marginBottom: 4, width: 6, height: 6, borderRadius: 3 }} />
                                }
                            </Grid>
                            <Grid style={{ alignItems: 'flex-start', marginLeft: 10, flex: 1, borderBottom: 1, borderBottomColor: '#F2F2F2' }}>
                                <Typography style={{ color: '#0D0D0D', fontSize: 14 }}>{nick}</Typography>
                                <Typography noWrap className={classes.contents} style={{ width: 200 }}>{userId}</Typography>
                                {/* <Grid style={{ height: 1, width: '100%', backgroundColor: '#FAFAFA', marginTop: 8 }}></Grid> */}
                            </Grid>
                        </Grid>
                    </Grid >
                    {
                        isDiv && <Grid style={{ height: 1, width: '100%', backgroundColor: '#FAFAFA', marginTop: 8, marginLeft: 50 }}></Grid>
                    }


                </Grid>
            </ListItem>
        );
    }
    rendArr = (data, n) => {
        if (data.list.length == 0) {
            return <div key={n}></div>
        }
        return (
            <div key={n}>
                <div style={{ width: '100%', backgroundColor: '#EFEFF4', height: 20, color: '#919191', fontSize: '10px', lineHeight: '25px', paddingLeft: 10, marginBottom: 8 }}>
                    {data.sort}
                </div>
                {
                    data.list.map((item, n) => (
                        this.renderItem(item, n, data.list.length > 1)
                    ))
                }
            </div>
        )
    }

    render() {
        const { classes } = this.props;
        const { friendList, is_group, applyPoint } = this.state;
        let title = '好友';
        let hideBack = true;
        if (AppData.ServerConfig && AppData.ServerConfig.tap_show == 1) {
            title = '我的通讯';
            hideBack = false;
        }

        return (
            <MBack title={title} hideBack={hideBack} style={{ overflowX: 'hidden' }} titlechildren={<Grid>
                {
                    is_group == 1 && <IconButton onClick={() => this._onSearchFriend()} style={{ position: 'absolute', right: 8, top: 8 }}>
                        <img src={ICON_ADD_FRIEND} style={{ width: 15, height: 15 }}></img>
                    </IconButton>
                }
            </Grid>}>
                <Grid style={{ height: 16 }}></Grid>
                <ChatItem title='群聊' divider={false} icon={1} onClick={() => this.onQunliao()} />
                <ChatItem title='新的好友' divider={true} showPoint={applyPoint} icon={2} onClick={() => this.onAddNewFriend()} />
                <Grid container justifycontent='flex-start' >
                    <List style={{ width: '100%' }}>
                        {
                            friendList.map((data, n) => (
                                this.rendArr(data, n)
                            ))
                        }
                    </List>
                </Grid>
                <div style={{ height: 80 }}></div>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    tittle: {
        color: '#0D0D0D',
        padding: theme.spacing(0, 2),
        fontSize: 14,
    },
    contents: {
        color: '#878787',
        fontSize: 12,
    },
    menuIcon: {
        color: theme.palette.secondary,
        margin: theme.spacing(0),
        width: 40,
        height: 40,
    },
    divider: {
        width: '100vw',
        height: 10,
        backgroundColor: '#FAFAFA',
        margin: theme.spacing(1, 0, 1, 0),
    }


}))(ChatPage));